export default {
  VEHICLE_INFO_TITLE: 'Vehicle Wheel Info',
  VEHICLE_WIDGET_COLLAPSIBLE_CLASS: 'container',
  VEHICLE_CATEGORY_REPEATER_CLASS: 'cm_vehicle-categories_category-wrapper-repeater',

  GARAGE_SIZE: '<span class="garage-size cart_count" key="garage-size">{{size}}</span>',
  GARAGE_CLASS: 'site-nav__link--icon',
};
